// Premises Helpers
// --------------------------------------------------------
const state = {
  topics: [], // Temporal list of topicsId used to create/edit Premises
  commentId: null // Temporal reference used to edit comments
}

const getters = {
  tempTopics: state => state.topics,
  tempComment: state => state.commentId,
  landscapePath(state, getters, rootState, rootGetters) {
    const landscapeId = rootGetters.currentLandscape._id
    return `landscapes/${landscapeId}`
  },
  premisesPath(state, getters) {
    return `${getters.landscapePath}/premises`
  },
  actorPath: (state, getters, rootState, rootGetters) => (
    premise = null,
    actorId = null
  ) => {
    if (actorId === null) {
      premise = premise || rootGetters['premises/current']
      actorId = premise.actorId
    }
    return `${getters.landscapePath}/actors/${actorId}/premises`
  },
  premisePath: (state, getters, rootState, rootGetters) => (premise = null) => {
    premise = premise || rootGetters['premises/current']
    const actorPath = getters.actorPath(premise)
    return `${actorPath}/${premise._id}`
  },
  commentPath: (state, getters, rootState, rootGetters) => {
    const premise = rootGetters['premises/current']
    const premisePath = getters.premisePath(premise)
    return `${premisePath}/comments`
  },
  hasAdminRights: (state, getters, rootState, rootGetters) => premise => {
    return (
      rootGetters.hasManagerRightsActor({_id: premise.actorId}) ||
      premise.author === rootGetters.userId
    )
  }
}

const mutations = {
  addTempTopic(state, topicId) {
    state.topics.push(topicId)
  },
  removeTempTopic(state, topicId) {
    const index = state.topics.findIndex(id => id === topicId)
    state.topics.splice(index, 1)
  },
  addTempTopics(state, topics) {
    state.topics = []
    topics.map(topic => state.topics.push(topic._id))
  },
  removeTempTopics(state) {
    state.topics = []
  },
  setTempComment(state, commentId) {
    state.commentId = commentId
  },
  removeTempComment(state) {
    state.commentId = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
